var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"statistic-card text-center"},[_c('v-card-text',[_c('div',{staticClass:"statistic-value"},[_vm._v(" "+_vm._s(_vm.value)+" ")]),_c('div',{staticClass:"statistic-title"},[_vm._v(" "+_vm._s(_vm.title)+" ")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }